import { LoggerCategoryEnum, LoggerLevelEnum } from './LoggerCore.types';
export function getInitialLogQueue() {
    const data = {
        [LoggerCategoryEnum.default]: [],
        [LoggerCategoryEnum.analytics]: [],
        [LoggerCategoryEnum.diagnostic]: [],
        [LoggerCategoryEnum.api]: [],
        [LoggerCategoryEnum.ui]: []
    };
    return data;
}
export const logLevels = [LoggerLevelEnum.log, LoggerLevelEnum.info, LoggerLevelEnum.debug, LoggerLevelEnum.warn, LoggerLevelEnum.error];
//# sourceMappingURL=LoggerCore.utils.js.map